// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"4b05235c","266":"9727124c","283":"db030823","400":"5ee507d4","814":"50019c14","988":"0cf68d8b"}[chunkId] + ".chunk.css";
};